interface SplitPillProps {
    left: string;
    leftTitle?: string;
    right: string;
    rightTitle?: string;
    button?: string | null;
    handleButtonClick?: () => void;
}

export const SplitPill = ({left, leftTitle, right, rightTitle, button, handleButtonClick}: SplitPillProps) =>
    <div className="split-pill mb-2 mr-1">
        <span title={leftTitle}>{left}</span>
        <span title={rightTitle}>{right}</span>
        {button && <span><button onClick={handleButtonClick}>{button}</button></span>}
    </div>;
